import * as yup from "yup";
import { FormInputMeta } from "@Modules/core/types/FormMetaType";
import { getValidationSchema } from "@Shared/utils/validationSchema";

export interface ICountryDataTableRowFormMeta {
    associationTable: FormInputMeta,
    nameTable: FormInputMeta,
    alphaCodeTable: FormInputMeta,
    numCodeTable: FormInputMeta,
    schema: any;
}

const CountryDataTableRowFormMeta = {} as ICountryDataTableRowFormMeta;

    CountryDataTableRowFormMeta.associationTable = {
    name: "associationTable",
    label: "Association",
    type: "text",
    validation: yup.string().required(),
  }
  CountryDataTableRowFormMeta.nameTable = {
    name: "nameTable",
    label: "Nom",
    type: "text",
    validation: yup.string().required(),
  }
  CountryDataTableRowFormMeta.alphaCodeTable = {
    name: "alphaCodeTable",
    label: "Code Alpha.",
    type: "number",
    validation: yup.string().required(),
  }
  CountryDataTableRowFormMeta.numCodeTable = {
    name: "numCodeTable",
    label: "Code Num.",
    type: "number",
    validation: yup.string().required(),
  }

CountryDataTableRowFormMeta.schema = yup.object().shape(getValidationSchema(CountryDataTableRowFormMeta));

export default CountryDataTableRowFormMeta;